<router-outlet *ngIf="getPageDate"></router-outlet>
<ngx-ui-loader></ngx-ui-loader>